import React from 'react';
import { Button, Form } from 'react-bootstrap';

export type WebPlatform = 'mobile' | 'desktop';

interface Props {
    value: string;
    onChange: (platform: WebPlatform) => void;
}

const PlatformToggle: React.FC<Props> = ({ value, onChange }) => (
    <Form.Group className="mt-3 mb-2">
        <Form.Label className="m-2 mt-3">Platform</Form.Label>
        <div className="d-flex gap-2 ms-2">
            <Button
                type="button"
                variant={value === 'mobile' ? 'success' : 'outline-success'}
                onClick={() => onChange('mobile')}
            >
                Mobile
            </Button>
            <Button
                type="button"
                variant={value === 'desktop' ? 'success' : 'outline-success'}
                onClick={() => onChange('desktop')}
            >
                Desktop
            </Button>
        </div>
    </Form.Group>
);

export default PlatformToggle;
